<template>
	<v-col class="pa-0">
		<v-row class="mb-3">
			<v-col cols="6">
				<v-btn depressed color="grey lighten-2" class="rounded-xl" @click="goBack">
					<v-icon small>mdi-arrow-left</v-icon>
					<span class="pl-2">Kembali</span>
				</v-btn>
			</v-col>
			<v-col cols="6" class="text-right">
				<v-btn depressed color="primary" class="rounded-xl" @click="goPrint">
					<v-icon small color="white">mdi-printer</v-icon>
					<span class="pl-2">Print</span>
				</v-btn>
			</v-col>
		</v-row>
		<div id="section-to-print" class="overflow-hidden">
			<div class="my-3">
				<img width="90" height="auto" src="/img/ic-logo.svg">
				<v-row>
					<v-col cols="12" sm="6">
						<div class="font-size-11 font-weight-500">Damai Sinergi Nusantara</div>
						<div class="font-size-10">Jl Raya Ringin Ngulanwetan Pogalan - Trenggalek - Jawa Timur INDONESIA 66371</div>
						<div class="font-size-10">Hp : 0822-3114-0366</div>
						<div class="font-size-10">Email : ybfcpanzer@yahoo.com</div>
					</v-col>
					<v-col cols="12" sm="6" class="pt-0 text-right mt-auto">
						<div class="font-size-10">Tanggal {{ new Date() | tanggal }}</div>
					</v-col>
					<v-col cols="12" class="pt-0">
						<div class="border-bottom border-grey border-2px"></div>
					</v-col>
				</v-row>
			</div>

			<v-row>
				<v-col cols="6" md="9">
					<div>
						<div class="font-size-10">Kode Mitra</div>
						<div class="font-size-10 cl-secondary font-weight-500">{{ userData.member_network_code }}</div>
					</div>
					<div class="pt-2">
						<div class="font-size-10">Nama Mitra</div>
						<div class="font-size-10 cl-secondary font-weight-500">{{ userData.member_name }}</div>
					</div>
				</v-col>
				<v-col cols="6" md="3" class="text-right">
					<div>
						<div class="font-size-10">Nama Bank</div>
						<div class="font-size-10 cl-secondary font-weight-500">{{ userData.member_bank_name ? userData.member_bank_name : '-' }}</div>
					</div>
					<div class="pt-2">
						<div class="font-size-10">Nomor Rekening</div>
						<div class="font-size-10 cl-secondary font-weight-500">{{ userData.member_bank_account_no ? userData.member_bank_account_no : '-' }}</div>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4" class="border-bottom border-grey border-2px">
					<div class="font-size-10 font-weight-bold">Start(Rp)</div>
				</v-col>
				<v-col cols="4" class="text-center border-bottom border-grey border-2px">
					<div class="font-size-10 font-weight-bold">Pasangan(Rp)</div>
				</v-col>
				<v-col cols="4" class="text-right border-bottom border-grey border-2px">
					<div class="font-size-10 font-weight-bold">RO (Rp)</div>
				</v-col>
				<v-col cols="12" class="pa-0">
					<div class="d-flex flex-wrap" v-for="(data, i) in dataPrint" :key="i">
						<v-col cols="4" class="border-bottom border-grey border-2px">
							<div class="font-size-10">{{ data.bonus_log_start | toNumber }}</div>
						</v-col>
						<v-col cols="4" class="text-center border-bottom border-grey border-2px">
							<div class="font-size-10">{{ data.bonus_log_match | toNumber }}</div>
						</v-col>
						<v-col cols="4" class="text-right border-bottom border-grey border-2px">
							<div class="font-size-10">{{ data.bonus_log_ro | toNumber }}</div>
						</v-col>
					</div>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="6" md="6" class="pb-0 pr-0">
					<div class="font-size-10 font-weight-bold">Total Komisi</div>
					<div class="pt-3 border-bottom border-grey border-2px"></div>
				</v-col>
				<v-col cols="6" md="6" class="pb-0 pl-0 text-right">
					<div class="font-size-10 font-weight-bold">{{ sumTotal | toRupiah }}</div>
					<div class="pt-3 border-bottom border-grey border-2px"></div>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
		}
	},
	props: {
		dataPrint: Array,
	},
	computed: {
		...mapState('auth', ['userData']),

		sumTotal() {
			let total = 0
			this.dataPrint.forEach((el) => {
				total += parseInt(el.bonus_log_start) + parseInt(el.bonus_log_match) + parseInt(el.bonus_log_ro)
			})
			return total
		}
	},
	methods: {

		goPrint() {
			window.print()
		},
		goBack() {
			this.$emit('action', '0')
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Print Histori Komisi`)
	}
};
</script>